import React, { useContext, useEffect, useState } from "react";
import Filters from "components/ClientSearch/Filters";
import Listings from "components/ClientSearch/Listings";
import CMSContentWrapper from "components/CMSContentWrapper";
import Map from "components/ClientSearch/Map";
import { areaQueryWithCmsContent_area_Market_cmsContent } from "types/pages/office-space/m/areaQueryWithCmsContent";
import cssVars from "styles/variables.json";
import { useCurrentUser } from "hooks";
import QueryManagerContext from "context/QueryManager/QueryManagerContext";
import Toolbar from "components/ClientSearch/Toolbar";
import AggregateHeader from "components/ClientSearch/Listings/AggregateHeader";
import dynamic from "next/dynamic";
import FlexBanner from "./FlexBanner";

import styles from "./styles.module.scss";
import BreadCrumbs from "./BreadCrumbs";
import SEOFooter from "./SEOFooter";

const ChatCTA = dynamic(() => import("components/ChatModalCTA"));

type Props = {
  sanitizedCMS: areaQueryWithCmsContent_area_Market_cmsContent;
  externalId: string;
};

const ICESearch = ({ sanitizedCMS, externalId }: Props) => {
  const [hoveredListingId, setHoveredLsitingId] = useState<string | null>(null);

  const isDesktop = () =>
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia(`(min-width: ${cssVars["bp-mobile"]})`).matches;

  const [isLaregerThanMobile, setIsLargerThanMobile] = useState(isDesktop());
  const { currentUser } = useCurrentUser();
  const { values } = useContext(QueryManagerContext);

  const shouldMapRender = () => {
    setIsLargerThanMobile(isDesktop());
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", shouldMapRender);
    }
    return () => {
      window.removeEventListener("resize", shouldMapRender);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!currentUser && <FlexBanner dismissible={false} />}
      <div className={`inset ${styles.layout}`}>
        <div className={styles.niceFilter}>
          {isLaregerThanMobile && <Filters />}
        </div>
        <hr />
        <AggregateHeader
          areas={[...values.neighborhoods, ...values.submarkets]}
          marketName={values.market?.name}
          count={values.count}
        />
        <BreadCrumbs className={styles.breadcrumbs} />
        <div className={styles.mainSection}>
          <div className={styles.listingsContainer}>
            <Listings onHoverListing={(id) => setHoveredLsitingId(id)} />
          </div>
          <div className={styles.mapPlaceholder} data-qa="ice-map-container">
            {isLaregerThanMobile && <Map hoveredListingId={hoveredListingId} />}
          </div>
        </div>
        <ChatCTA
          loggedIn={!!currentUser}
          neighborhoods={values.neighborhoods || []}
          submarkets={values.submarkets || []}
          market={values.market?.externalId}
          className={styles.chatModalCta}
          buttonText={isLaregerThanMobile ? "Chat with us" : "Chat"}
        />
        {!isLaregerThanMobile && <Toolbar />}
      </div>
      {sanitizedCMS?.content && (
        <CMSContentWrapper
          className="inset-layout"
          externalId={externalId}
          sanitizedTitle={sanitizedCMS.title}
          sanitizedContent={sanitizedCMS.content}
          faq={sanitizedCMS?.faq}
        />
      )}

      {values.market && (
        <SEOFooter
          marketUuid={values.market.externalId}
          currentAreaUuid={values.area}
        />
      )}
    </>
  );
};

export default ICESearch;
